module.exports = __webpack_public_path__ + "static/level_1.abd69366.png";